import { normalizeEmail } from '@/config/authAllowlist';

/** Build a login email from a display name and the creator's email domain. */
export function suggestEmailFromName(
  firstName: string,
  lastName: string,
  creatorEmail: string
): string {
  const domain = normalizeEmail(creatorEmail).split('@')[1] ?? 'assaabloy.com';
  const localFirst = firstName.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
  const localLast = lastName.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
  const local = localLast ? `${localFirst}.${localLast}` : localFirst;
  return `${local || 'user'}@${domain}`;
}
